export default __webpack_public_path__ + "static/media/trampapo_02_26.8e5ec425.jpg";